import { useState, useEffect } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Why Us", href: "/#why" },
  { label: "Results", href: "/#metrics" },
  { label: "Clients", href: "/#testimonials" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-white border-b border-[#E5E5E5] transition-shadow ${
        scrolled ? "shadow-[0_1px_0_0_#0A0A0A]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 md:h-28 flex items-center justify-between">
        <a
          href="/#top"
          data-testid="brand-logo"
          className="flex items-center"
        >
          <img
            src="/novaworks-logo.png"
            alt="NovaWorks Global Solutions"
            className="h-[72px] md:h-24 w-auto"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-xs tracking-[0.18em] uppercase font-bold text-[#0A0A0A] hover:text-[#002DFF] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="/#contact"
          data-testid="header-cta"
          className="hidden md:inline-flex items-center gap-2 bg-[#0A0A0A] text-white px-5 py-3 text-xs font-bold uppercase tracking-[0.15em] border border-[#0A0A0A] hover:bg-[#002DFF] hover:border-[#002DFF] transition-colors"
        >
          Get a Quote <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
        </a>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5E5E5] bg-white" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.15em] uppercase font-bold"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contact"
              onClick={() => setOpen(false)}
              className="bg-[#0A0A0A] text-white px-5 py-3 text-xs font-bold uppercase tracking-[0.15em] text-center"
            >
              Get a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
